import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { Divider } from "@mui/material";
import { StepContent } from "./stepContent";
import { StepperCTA } from "./stepperCTA";
const steps = ["Requirements", "Input Color", "Evaluation Result"];
import { useStoreActions, useStoreState } from "easy-peasy";
export default function StepperContainer() {
  const [activeStep, setActiveStep] = React.useState(0);
  let setRequirements = useStoreActions((actions) => actions.setRequirements);
  let setInputColor = useStoreActions((actions) => actions.setInputColor);
  let requirements = useStoreState((state) => state.requirements);
  const setNewFormErrors = useStoreActions(
    (actions) => actions.setNewFormErrors
  );

  let clearRequirementPage = () => {
    setRequirements({
      resinRequirement: {
        newResinvirgin: "",
        newResinRecycled: {
          resinName: "",
          batchNumber: "",
          thickness: "",
          rtCurve: {},
          // fileName: "",
          dilutionDetails: {
            recycledResinConc: "",
            virginResinConc: "",
          },
        },
      },
      resinClass: "PO",
    });
  };

  const handleNext = (isFormClear) => {
    if (isFormClear && activeStep === 2) {
      /* 
          Start new prediction block
          Clear requirement page data
          Clear Input color page data
          Clear all resin uploaded files
          Clear all validation data
      */
      clearRequirementPage();
      setInputColor({ uploadedColorArray: [], fileName: "" });
      setRequirements({
        selectedVirginResin: "",
        resinRequirement: {
          newResinRecycled: {
            fileName: "",
          },
          newResinvirgin: {
            fileName: "",
          },
        },
      });
      setNewFormErrors(() => {
        // This `prevErrors` is the latest state from the store
        return {
          thickness: {
            required: true,
            highlight: false,
          },
          ldr: {
            required: true,
            highlight: false,
          },
          recycledResinConc: {
            required: true,
            highlight: false,
          },
          tar: "",
          cadr: "",
          requestNumber: {
            required: true,
            highlight: false,
          },
          virgin: {
            required: true,
            highlight: false,
          },
          recycled: {
            required: true,
            highlight: false,
          },
        };
      });
    }

    activeStep === 2
      ? setActiveStep((prevActiveStep) => prevActiveStep - 2)
      : setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = (isFormClear) => {
    if (!isFormClear && activeStep === 2) {
      /* 
        Change requirement block
        Clear Input color uploaded files
        Clear all resin uploaded files
      */
      //setInputColor({ uploadedColorArray: [], fileName: "" });
      setRequirements({
        ...requirements,
        // resinRequirement: {
        //   //newResinvirgin: requirements.resinRequirement.newResinvirgin,
        //   // newResinRecycled: {
        //   //   fileName: "",
        //   // },
        //   // newResinvirgin: {
        //   //   fileName: "",
        //   // },
        // },
        resinClass: requirements?.resinClass,
      });
    }
    activeStep === 2
      ? setActiveStep((prevActiveStep) => prevActiveStep - 2)
      : setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ ml: "20%", mr: "20%", mb: "2%" }}>
        <Stepper activeStep={activeStep}>
          {steps.map((label, index) => {
            const stepProps = {};
            const labelProps = {};

            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
      </Box>

      <Divider />

      <Box
        sx={
          activeStep != 2
            ? { ml: "20%", mr: "20%", mb: "2%" }
            : { ml: "4%", mr: "4%", mb: "2%", mt: "2%" }
        }
      >
        <StepContent activeStep={activeStep} />
      </Box>

      <Divider />

      <StepperCTA
        activeStep={activeStep}
        handleNext={handleNext}
        handleBack={handleBack}
        stepsLength={steps.length}
      />
    </Box>
  );
}
